<template>
  <div>
    <!-- BEGIN Illustration -->
    <div class="w-full flex justify-center h-36 my-10">
      <img
        v-if="name === 'GRATUIT'"
        src="/assets/img/abonnements/Illustration_Gratuit.png"
        alt="Abonnement Gratuit"
      >
      <img
        v-else-if="name === 'PILOTE'"
        src="/assets/img/abonnements/Illustration_Standart.png"
        alt="Abonnement Pilote"
      >
      <img
        v-else-if="name === 'EXPERT'"
        src="/assets/img/abonnements/Illustration_Plus.png"
        alt="Abonnement Expert"
      >
    </div>
    <!-- END Illustration -->


    <!-- BEGIN nom -->
    <h2
      class="text-4xl font-medium"
      :class="`text-${colorTheme(name, true)}-600`"
    >
      {{ name }}
    </h2>
    <!-- END nom  -->
    <!-- BEGIN Description -->
    <p class="text-base text-center mt-5">
      {{ description }}
    </p>
    <!-- END Description -->
  </div>
</template>
<script>
import colorTheme from './colorTheme';

export default {
  methods: {colorTheme},
  props: {
    name: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true
    }
  },
};
</script>